<template>
  <div class="tooltip-container" :class="{'tooltip-active': visibility}">
    <div class="tooltip-tip ">
      <div class="tooltip-tip__arrow"></div>
      <div class="tooltip-tip__text">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Tooltip",

    props: {
      visibility: {
        type: Boolean,
        required: true
      },

      onClose: {
        type: Function,
        required: true
      }
    },

    mounted() {
      this._onEscPressed = (ev) => {
        if (ev.keyCode === 27) {
          this.onClose();
        }
      };

      this._onMouseClicked = () => {
        if (!this._isMouseOver) this.onClose();
      };

      window.addEventListener('keyup', this._onEscPressed);
      window.addEventListener('click', this._onMouseClicked);

      this.$el.addEventListener('mouseenter', () => {
        this._isMouseOver = true;
      });

      this.$el.addEventListener('mouseleave', () => {
        this._isMouseOver = false;
      });
    },

    beforeDestroy() {
      window.removeEventListener('keyup', this._onEscPressed);
      window.removeEventListener('click', this._onMouseClicked);
    }
  }
</script>

<style scoped>

</style>
